import { Tag, Tooltip, Typography } from "@timeedit/ui-components";
import cn from "classnames";
import "./waitlistTag.scss";
import { isDefined } from "@timeedit/registration-schemas";
import { translations } from "@timeedit/registration-shared";
import Queue from "@timeedit/ui-components/icons/Queue";
import SwapOutlined from "@timeedit/ui-components/icons/SwapOutlined";

type WaitlistTagProps = {
  tooltipTitle?: string;
  inWaitlist: number | undefined;
  leaving?: number;
  alwaysDisplay?: boolean;
  className?: string;
};

/*
 * @param leaving - Number of leaving students
 * @param inWaitlist - Number of students in waitlist
 * @param tooltipTitle - The tooltip to be shown
 * @param alwaysDisplay - If we should display even if waitlist is empty
 * @param className - CSS classname for the span container
 */
export function WaitlistTag({
  leaving,
  inWaitlist = 0,
  tooltipTitle,
  alwaysDisplay,
  className,
}: WaitlistTagProps): React.ReactNode {
  if (!alwaysDisplay && inWaitlist === 0) return null;

  return (
    <Tooltip title={tooltipTitle}>
      <Tag
        className={cn("waitlist-tag", className)}
        icon={
          <>
            <Queue alt={translations.waitlist} />
            <Typography.Text
              className={cn({ "waitlist-tag-novalue": inWaitlist === 0 })}
            >
              {inWaitlist}
            </Typography.Text>

            {isDefined(leaving) && (
              <span className="waitlist-tag-leaving">
                <SwapOutlined alt={translations.leavingWaitlistDescription} />
                <Typography.Text
                  className={cn({ "waitlist-tag-novalue": leaving === 0 })}
                >
                  {leaving}
                </Typography.Text>
              </span>
            )}
          </>
        }
      ></Tag>
    </Tooltip>
  );
}
